export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="contact" className="w-full bg-background-200 pt-12 md:pt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 pb-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sun-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950 md:text-2xl">动漫之家</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              动漫之家官网地址更新、网页版与 APP 下载入口整理站。遇到动漫之家打不开或换网址，
              记得先回这里，帮你快速回到追番页面。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-qq-line", "ri-bilibili-fill", "ri-mail-line"].map((i) => (
                <a
                  key={i}
                  href="#contact"
                  aria-label="社交入口"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${i} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "#access", label: "访问入口" },
                { href: "#webapp", label: "网页版·APP" },
                { href: "#popular", label: "番剧推荐" },
                { href: "#faq", label: "常见问题" },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">联系与帮助</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span className="whitespace-nowrap">support@dongmanzhijia.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>官网地址 7×24 小时同步更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-line"></i>请认准官方入口，谨防仿冒
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-300 py-5 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {year} 动漫之家入口导航站 · 本页仅整理动漫之家官网入口与访问帮助
          </p>
          <p className="text-xs text-foreground-600">正版追番，快乐追漫</p>
        </div>
      </div>
    </footer>
  );
}